class OffersCounter {

    constructor($) {
        this._containers = document.querySelectorAll('[data-contains="offers-counter"]');

        $(document).on('offers-counter:fill', (event, payload) => {
            return this._fill(payload);
        });
    }

    _fill(payload = 0) {
        const fill = this._parsePayload(payload);

        this._containers.forEach(container => {
            container.innerText = fill;
        });
    }

    _parsePayload(length = 0) {
        let str = 'Znaleźliśmy ' + length + ' ';

        if( length === 1 )
        {
            str += 'ofertę';
        }
        else if(length % 10 > 1 && length % 10 < 5 && (length < 10 || length > 20))
        {
            str += 'oferty';
        }
        else
        {
            str += 'ofert';
        }

        return str;
    }
}

try {
    (function($) {
        new OffersCounter($);
    })(window.jQuery);
} catch( e ) { console.log(e); }